module.exports = __webpack_public_path__ + "static/img/pure-pollo.3388729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/pure-pollo.png
// module id = 246
// module chunks = 1